import axios from "axios"
import { getHeaders } from "services/AuthHeader";
import { ReservationI } from "types/ReservationsI";
import { ReservationResponse } from "types/responses/ReservationResponse";
import { ResponseError } from "types/responses/ResponseError";

const API_URL = process.env.REACT_APP_API_URL;
async function getUserReservationsHistory(client_id: any, from_record: number, to_record: number) {
    try {
        // console.log("getUserReservationsHistory");
        

        const response = await axios.get(
            API_URL + '/user/reservations/history',
            { 
                params: {
                    client_id: client_id,
                    from_record: from_record, 
                    to_record: to_record
                }, 
                headers: getHeaders() 
            }
        )
        // console.log(response);
        // console.log(response.data.reservations);

        if (!('reservations' in response.data)) {
            throw Error
        }
        if ('error' in response.data) {
            return response.data.error
        }
        
        
        const json: ReservationResponse[] = JSON.parse(response.data.reservations)
        let reservations: ReservationI[] = []
        json.forEach((value, index) => {
            let r: ReservationI = {
                name: value?.NAZEV,
                coach: value.INSTRUKTOR,
                coach_id: value.ID_TRENER,
                reservation_source: value.PUVOD,
                sports_ground_id: value.ID_SPORTOVISTE,
                lesson_id: value.ID_LEKCE,
                original_price: value.CENA_ORIGINAL,
                date: new Date(value.DATUM),
                length: value.DELKA,
                description: value.POPIS,
                reservation_date: new Date(value.DATUM_REZERVACE),
                done: value?.PROBEHLO
            }
            reservations.push(r)
        })


        return reservations

    } catch (error) {
        // console.log(error);
        
        return ResponseError.general_error
    }
}

export default getUserReservationsHistory